import BaseModule from '@/store/baseModule';
import BaseModulePlugins from '@/store/baseModule/plugins';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';

export default (store) => {
  store.registerModule(
    ['actions', 'status'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({
          url: `${process.env.MYPREDITY_BASE_URI}/actions/status`,
        }),
        retry: { nbLeft: 3, timeout: 2000 },
      }),
    })
  );

  const basePlugin = new BaseModulePlugins({
    module: 'actions/status',
    store,
  });
  basePlugin.onInit(() => store.dispatch('actions/status/initItems'));
};
